import React from 'react';

const ROLES = [
  {
    icon: 'pi pi-building',
    name: 'Research sites',
    copy: 'Run the clinic day from one screen.',
    items: [
      'Visit scheduling, check-in & encounters',
      'Coordinator worklists & task queues',
      'Consents, documents & eSource forms',
    ],
  },
  {
    icon: 'pi pi-globe',
    name: 'Sponsors & CROs',
    copy: 'Portfolio-level visibility without the email chase.',
    items: [
      'Multi-site startup & enrollment oversight',
      'Monitoring signals & protocol deviations',
      'Cross-study reports & dashboards',
    ],
  },
  {
    icon: 'pi pi-search',
    name: 'Monitors',
    copy: 'Everything needed for review — and nothing more.',
    items: [
      'Assignment-scoped workspace access',
      'Findings, queries & resolution tracking',
      'Audit evidence & visit documentation',
    ],
  },
  {
    icon: 'pi pi-cog',
    name: 'Operations & admin',
    copy: 'Governance that keeps pace with the work.',
    items: [
      'Roles, permissions & delegation logs',
      'Automation rules & system settings',
      'PTO coverage & training records',
    ],
  },
];

export default function RolesSection() {
  return (
    <section className="hx-roles" id="roles" aria-labelledby="roles-heading">
      <div className="hx-container">
        <div className="hx-section-head">
          <p className="hx-eyebrow">
            <span className="hx-eyebrow__tick" aria-hidden="true" />
            Built for the whole study team
          </p>
          <h2 className="hx-h2" id="roles-heading">
            Different seats, same source of truth.
          </h2>
        </div>

        <div className="hx-roles__grid">
          {ROLES.map((role) => (
            <article className="hx-roles__card" key={role.name}>
              <i className={`${role.icon} hx-roles__icon`} aria-hidden="true" />
              <h3 className="hx-roles__name">{role.name}</h3>
              <p className="hx-roles__copy">{role.copy}</p>
              <ul className="hx-roles__list">
                {role.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
